import { CircleAlert, Info } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

interface SignInAlertProps {
  /** `error` is announced at once (role="alert"); `info` is a polite status. */
  tone: 'error' | 'info';
  children: ReactNode;
}

/**
 * Why the person is on the sign-in page. A panel with a leading icon, so it is
 * not read as one more grey line: text and tint keep at least 4.5:1 in both themes.
 */
export function SignInAlert({ tone, children }: SignInAlertProps) {
  const isError = tone === 'error';
  const Icon = isError ? CircleAlert : Info;

  return (
    <div
      role={isError ? 'alert' : 'status'}
      className={cn(
        'flex items-start gap-3 rounded-md border px-3 py-2.5 text-sm font-medium',
        isError
          ? 'border-destructive/40 bg-destructive/10 text-destructive'
          : 'border-border bg-muted text-foreground',
      )}
    >
      <Icon aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      <p>{children}</p>
    </div>
  );
}
